export default __webpack_public_path__ + "static/media/bg.9c2c28a7.png";